import { Alert, CommentEmptyCloud, Heart, Reply } from '@zoomit/icons';
import { cssVar, theme } from '@zoomit/zoomit-ds';

export const generateTypeIcon = (type: string) => {
  switch (type) {
    case 'CommentReply':
      return <Reply fill={cssVar(theme.grey3)} />;
    case 'CommentLike':
      return <Heart fill={cssVar(theme.grey3)} />;
    case 'ProductPriceDrop':
      return <Alert size="sm" />;
    case 'ProductIsInStock':
      return <Alert size="sm" />;
    default:
      return <CommentEmptyCloud size="sm" fill={cssVar(theme.grey3)} />;
  }
};
